(ns frontend.ux-overhaul.listing.kyc.view
  (:require [common.localization :as loc]
            [common.opensearch.row :as os-row]
            [frontend.page-components.default-page-layout :as default-page-layout]
            [frontend.routing :as routing]
            [frontend.state.current-session :as session]
            [frontend.ux-overhaul.listing.generic.facets-event :as generic-facets-event]
            [frontend.ux-overhaul.listing.generic.event :as generic-event]
            [frontend.ux-overhaul.listing.generic.sub :as generic-sub]
            [frontend.ux-overhaul.listing.kyc.event :as kyc-event]
            [frontend.ux-overhaul.listing.kyc.sub :as kyc-sub]
            [frontend.ux-overhaul.listing.generic.view :as listing]
            [frontend.view.modals.bulk-edit-entity.view :as bulk-edit-modal]
            [frontend.view.not-found :as not-found]
            [ui.view.kanban-opensearch.event :as kanban-event]
            [re-frame.core :as rf]
            [reagent.core :as r]))

(def listing-id "kyc-listing")

(defn- open-kyc-profile!
  [value]
  (when-let [profile-id (os-row/entity-id value)]
    (routing/open-entity {:db/id       profile-id
                          :entity/type :entity.type/kyc-profile})))

(def page-content
  (r/create-class
   {:component-did-mount
    (fn []
      (rf/dispatch
       [::generic-event/init
        {:listing-id             listing-id
         :initial-view-mode      :kanban
         :entity-type            :entity.type/kyc-profile
         :pipeline-id            nil
         :filters                {:enabled? true
                                  :view-id :kyc
                                  :load-facets-event [::generic-facets-event/load-facets]}
         :available-view-modes   #{:kanban :grid :gallery :list}
         ;; Every :event here has to carry its own {:listing-id ...}. The
         ;; listing dispatches a vector :event verbatim - it appends nothing -
         ;; so a handler that destructures :listing-id from the event args gets
         ;; nil when the action omits it. That is not a loud failure: the export
         ;; handlers then resolved no runtime, fell through to the grid branch,
         ;; found no grid state and reported "No columns selected for export",
         ;; which made the export look broken in this listing's default kanban
         ;; view. Bulk delete silently became a no-op the same way.
         :toolbar-actions        [{:id       :create-kyc-profile
                                   :label    (loc/tr :kyc-profile-add-button)
                                   :visible? true
                                   :enabled? true
                                   :event    [::kyc-event/create-kyc-profile {:listing-id listing-id}]}
                                  {:id                  :bulk-edit-kyc-profiles
                                   :label               (loc/tr :bulk-edit)
                                   :visible?            true
                                   :enabled?            true
                                   :requires-selection? true
                                   :event               [::kyc-event/open-bulk-edit {:listing-id listing-id}]}
                                  {:id                  :bulk-delete-kyc-profiles
                                   :label               (loc/tr :confirm-delete-selected-button)
                                   :visible?            true
                                   :enabled?            true
                                   :requires-selection? true
                                   :event               [::kyc-event/bulk-delete-selected {:listing-id listing-id}]}
                                  {:id       :export-kyc-grid
                                   :label    (loc/tr :save-as-excel)
                                   :visible? true
                                   :enabled? true
                                   :event    [::kyc-event/export-grid {:listing-id listing-id}]}
                                  {:id       :export-kyc-grid-with-contacts
                                   :label    (loc/tr :save-as-excel-all-data)
                                   :visible? true
                                   :enabled? true
                                   :event    [::kyc-event/export-grid-with-contacts {:listing-id listing-id}]}]}]))

    :component-will-unmount
    (fn []
      (rf/dispatch [::generic-event/destroy listing-id]))

    :reagent-render
    (fn []
      (let [bulk-edit-open? @(rf/subscribe [::kyc-sub/bulk-edit-open?])
            selected-ids @(rf/subscribe [::generic-sub/selected-ids listing-id])
            context @(rf/subscribe [::generic-sub/context listing-id])
            accessible-field-paths (->> (or (:accessible-fields context) [])
                                        (keep :field-path)
                                        vec)
            setup-state (r/atom {:selected             (->> selected-ids
                                                            (map (fn [id] [id true]))
                                                            (into {}))
                                 :sorted-grid-entities (->> selected-ids
                                                            (mapv (fn [id]
                                                                    {:db/id id})))})
            setup-args {:state      setup-state
                        :column-keys (fn [] accessible-field-paths)
                        :mandatory?  (fn [_] false)}]
        [:<>
         [listing/view
          {:listing-id               listing-id
           :title                    (loc/tr :kyc-profiles)
           :show-view-mode-selector? true
           :query-placeholder        (loc/tr :listing.kyc-profile/search-placeholder)
           :on-create-first-item     #(rf/dispatch [::kyc-event/create-kyc-profile])
           :on-row-clicked           open-kyc-profile!
           :on-card-clicked          open-kyc-profile!}]
         (when bulk-edit-open?
           [bulk-edit-modal/view
            {:setup-args   setup-args
             :entity-type  :entity.type/kyc-profile
             :on-save-success #(rf/dispatch [::kanban-event/reload-visible-columns
                                             {:kanban-id (str listing-id "-kanban")}])
             :close-modal! #(rf/dispatch [::kyc-event/close-bulk-edit
                                          {:listing-id listing-id}])}])]))}))

(defmethod routing/render-view :kyc-grid
  [{:keys []}]
  (if (or (session/is-read-only-user?)
          (not (session/kyc?)))
    [not-found/not-found-view]
    [default-page-layout/view
     [:<>
      [page-content]]]))
